import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => {
  const t = localStorage.getItem("apex_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// Fetches dual scores; polls every 5s while some tickers are still computing (max ~4 min).
export const useDualScores = (tickers) => {
  const [scores, setScores] = useState({});
  const [pending, setPending] = useState([]);
  const key = [...new Set(tickers)].sort().join(",");
  const timer = useRef(null);

  useEffect(() => {
    if (!key) return undefined;
    let tries = 0;
    let alive = true;
    const tick = async () => {
      try {
        const r = await axios.post(`${API}/portfolio-engine/dual-score`, { tickers: key.split(",") }, { headers: auth() });
        if (!alive) return;
        setScores((s) => ({ ...s, ...Object.fromEntries(Object.entries(r.data.results).filter(([, v]) => v)) }));
        setPending(r.data.pending);
        if (r.data.pending.length && ++tries < 50) timer.current = setTimeout(tick, 5000);
      } catch (e) {
        if (alive && ++tries < 50) timer.current = setTimeout(tick, 8000);
      }
    };
    tick();
    return () => { alive = false; clearTimeout(timer.current); };
  }, [key]);

  return { scores, pending };
};
